import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { canShow } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
const SignInGateFakeSocial = React.lazy(() => {
    const { start, end } = initPerf('SignInGateFakeSocial');
    start();
    return import(
    /* webpackChunkName: "SignInGateFakeSocial" */ '../gateDesigns/SignInGateFakeSocial').then((module) => {
        end();
        return { default: module.SignInGateFakeSocial };
    });
});
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (_jsx(Lazy, Object.assign({ margin: 300 }, { children: _jsx(Suspense, Object.assign({ fallback: _jsx(_Fragment, {}, void 0) }, { children: _jsx(SignInGateFakeSocial, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment }, void 0) }), void 0) }), void 0)),
    canShow,
};
